// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e105b8e6","732":"9c50e257","977":"741fcb53"}[chunkId] + ".chunk.js";
};